import {
  FETCH_ADVFILTER_REQUEST,
  FETCH_ADVFILTER_SUCCESS,
  FETCH_ADVFILTER_FAILURE,
} from "./appoinmentAdvListTypes";
import api from "../../utils/Api";

export const fetchAdvFilteListRequest = () => {
  return {
    type: FETCH_ADVFILTER_REQUEST,
  };
};

export const fetchAdvFilteListSuccess = (AdvFilterList) => {
  return {
    type: FETCH_ADVFILTER_SUCCESS,
    payload: AdvFilterList,
  };
};

export const fetchAdvFilteListFailure = (error) => {
  return {
    type: FETCH_ADVFILTER_FAILURE,
    payload: error,
  };
};

export const fetchAdvFilteList = () => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchAdvFilteListRequest());
    try {
      const response = await api.get("appointment/filterdata/fetch", {
        headers: headers,
      });
      const AdvFilterList = response.data.data;
     // console.log("+++++++++++ advFilterList in redux ", AdvFilterList);
      dispatch(fetchAdvFilteListSuccess(AdvFilterList));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchAdvFilteListFailure(errorMsg));
    }
  };
};
